export default __webpack_public_path__ + "static/media/arrow-right-blue-icon.9c4c199c.svg";